import routerView from '@/views/layout/routerView'
import routerEnterpriseGraph from '@/views/layout/routerEnterpriseGraph'

export const   searchRoute = [
  {
    path: 'search',
    name: '智能查询',
    icon: 'icon-xiansuo2',
    icon_img: 'nav02',
    component: routerView,
    hidden: false,
    children: [
      {
        path: 'index',
        name: '企业查询',
        icon: 'icon-xiansuo2',
        hidden: false,
        component: () => import('@/views/clue/page/index'),
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '企业查询']
        }
      },
      {
        path: 'newsDetails',
        component: () => import('@/views/clue/page/newsDetails'),
        name: '企业资讯',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '企业资讯',
          icon: 'leftIcon1',
          breadcrumb: ['智能拓客', '智能查询', '企业资讯'],
          path: '/zxk/search/index'
        }
      },
      {
        path: 'clueList',
        component: () => import('@/views/clue/page/clueList'),
        name: '企业列表',
        hidden: true,
        hide: true,
        meta: {
          nextStart: true,
          title: '企业列表',
          icon: 'leftIcon1',
          breadcrumb: ['智能查询', '企业列表'],
          path: '/zxk/search/index'
        }
      },
      {
        path: 'newlyCompany',
        name: '新企查询',
        icon: 'icon-qiye-tianchong',
        hidden: false,
        component: () => import('@/views/clue/page/newlyCompany'),
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '新企查询']
        }
      },
      // {
      //   path: 'biddingInquiry',
      //   component: () => import('@/views/clue/page/biddingInquiry'),
      //   name: '招标查询',
      //   hidden: true,
      //   icon: 'icon-zhaotoubiaojieduan',
      //   meta: {
      //     nextStart: true,
      //     breadcrumb: ['智能查询', '招标查询']
      //   }
      // },
      {
        path: 'callForBidDetailList',
        component: () => import('@/views/clue/page/callForBidDetailList'),
        name: '公告详情',
        hidden: true,
        hide: true,
        icon: 'icon-sousuo-tianchong',
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '招标查询', '公告详情']
        }
      },
      {
        path: 'batchSearch',
        name: '批量查询',
        icon: 'icon-xiansuo2',
        hidden: false,
        component: () => import('@/views/search/page/batchSearch'),
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '批量查询']
        }
      }
    ]
  },
  {
    path: 'search',
    name: '智能查询',
    icon: 'icon-xiansuo2',
    icon_img: 'nav02',
    component: routerEnterpriseGraph,
    hide: true,
    hidden: true,
    children: [
      {
        path: 'equityPenetration',
        name: '股权穿透图',
        icon: 'icon-xiansuo2',
        hidden: true,
        hide: true,
        components: {
          header: () => import('@/views/clue/components/enterpriseTabs'),
          default: () => import('@/views/clue/page/equityPenetration'),
        },
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '股权穿透图'],
          highlight: '/zxk/search/index'
        }
      },
      {
        path: 'equityPenetration',
        name: '股权全景穿透',
        icon: 'icon-xiansuo2',
        hidden: true,
        hide: true,
        components: {
          header: () => import('@/views/clue/components/enterpriseTabs'),
          default: () => import('@/views/clue/page/equityPenetration'),
        },
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '股权全景穿透'],
          highlight: '/zxk/search/index'
        }
      },
      {
        path: 'enterpriseGraph',
        name: '企业架构图',
        icon: 'icon-xiansuo2',
        hidden: true,
        hide: true,
        components: {
          header: () => import('@/views/clue/components/enterpriseTabs'),
          default: () => import('@/views/clue/page/enterpriseGraph'),
        },
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '企业架构图'],
          highlight: '/zxk/search/index'
        }
      },
      {
        path: 'shareholderStructure',
        name: '股东持股穿透',
        icon: 'icon-xiansuo2',
        hidden: true,
        hide: true,
        components: {
          header: () => import('@/views/clue/components/enterpriseTabs'),
          default: () => import('@/views/clue/page/shareholderStructure'),
        },
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '股东持股穿透'],
          highlight: '/zxk/search/index'
        }
      },
      {
        path: 'investmentPenetration',
        name: '对外投资穿透',
        icon: 'icon-xiansuo2',
        hidden: true,
        hide: true,
        components: {
          header: () => import('@/views/clue/components/enterpriseTabs'),
          default: () => import('@/views/clue/page/investmentPenetration'),
        },
        meta: {
          nextStart: true,
          breadcrumb: ['智能查询', '对外投资穿透'],
          highlight: '/zxk/search/index'
        }
      },
    ]
  }
]
export default searchRoute
